module.exports = __webpack_public_path__ + "img/AC_S1_Calendar.9e265bd7.jpg";